import { ExternalLink } from "@/components/ExternalLink";
import { siteLinks } from "@/config/branding";

interface ConsentNoticeProps {
  /** What RequirementONE will generate after submit. */
  deliverable: "coverage report" | "obligations export";
}

export function ConsentNotice({ deliverable }: ConsentNoticeProps) {
  return (
    <p className="mt-4 text-sm text-ink-muted">
      By submitting, you agree to our{" "}
      <ExternalLink href={siteLinks.terms} className="font-medium text-brand-600 underline">
        Terms
      </ExternalLink>{" "}
      and{" "}
      <ExternalLink href={siteLinks.privacy} className="font-medium text-brand-600 underline">
        Privacy Policy
      </ExternalLink>
      , and that RequirementONE may process the uploaded documents to generate your {deliverable}.
    </p>
  );
}
